import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import Link from 'flarum/common/components/Link';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import LinkButton from 'flarum/common/components/LinkButton';

import extendUserModel from '../common/models';
import AltsPage from './components/AltsPage';
import IdentityPicker from './components/IdentityPicker';
import { activeAlts, canCreateAlts, loadAlts } from './altsStore';

app.initializers.add('nurriemunchers-alts', () => {
  extendUserModel();

  app.routes['nurriemunchers-alts.index'] = { path: '/alts', component: AltsPage };

  // ---------------------------------------------------------------------
  // "Posting as" picker
  // ---------------------------------------------------------------------
  [ReplyComposer, DiscussionComposer].forEach((Composer) => {
    // Fetch the alt list when a composer opens rather than at boot. Initializers
    // run before core creates app.session and app.forum, so there is nothing to
    // ask about yet at that point — and the request would go out on every page
    // load whether or not anyone intended to post.
    extend(Composer.prototype, 'oninit', function () {
      loadAlts();
    });

    extend(Composer.prototype, 'headerItems', function (items) {
      if (!activeAlts().length) return;

      items.add('nurriemunchers-alts-identity', <IdentityPicker composer={this} />, -10);
    });

    extend(Composer.prototype, 'data', function (data) {
      if (this.altId) {
        data.altId = this.altId;
      }
    });
  });

  // ---------------------------------------------------------------------
  // Moderator badge
  // ---------------------------------------------------------------------
  // The server only reports isAlt to moderators and to the alt's own owner, so
  // this renders for nobody else — the check here is presentation, not access
  // control.
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const user = this.attrs.post.user();

    if (!user || !user.isAlt || !user.isAlt()) return;

    const owner = user.altOwnerUsername();

    items.add(
      'nurriemunchers-alts-badge',
      owner ? (
        <Link
          className="NurrieAlts-badge"
          href={app.route('user', { username: owner })}
          title={app.translator.trans('nurriemunchers-alts.forum.post.alt_badge_tooltip', { username: owner })}
        >
          {app.translator.trans('nurriemunchers-alts.forum.post.alt_badge')}
        </Link>
      ) : (
        <span className="NurrieAlts-badge">
          {app.translator.trans('nurriemunchers-alts.forum.post.alt_badge')}
        </span>
      ),
      -5
    );
  });

  // ---------------------------------------------------------------------
  // Navigation
  // ---------------------------------------------------------------------
  // The main navigation — the list carrying All Discussions, Following and
  // Tags. On phones core folds exactly this list into the title dropdown, so
  // adding it here is what gives the feature a front door on mobile rather
  // than burying it behind an avatar tap.
  extend(IndexPage.prototype, 'navItems', function (items) {
    if (!canCreateAlts()) return;

    items.add(
      'nurriemunchers-alts',
      <LinkButton icon="fas fa-theater-masks" href={app.route('nurriemunchers-alts.index')}>
        {app.translator.trans('nurriemunchers-alts.forum.nav.alts')}
      </LinkButton>,
      -10
    );
  });

  extend(SessionDropdown.prototype, 'items', function (items) {
    if (!canCreateAlts()) return;

    items.add(
      'nurriemunchers-alts',
      <LinkButton icon="fas fa-theater-masks" href={app.route('nurriemunchers-alts.index')}>
        {app.translator.trans('nurriemunchers-alts.forum.nav.alts')}
      </LinkButton>,
      75
    );
  });
});
